export function CheckStoreWebOpen(store: any) {
    return store?.online_web_ordering_status != 1 //0; // 1 for order yes and 0 for order no
}